import axios from 'axios'

const BASE_URL = `${process.env.REACT_APP_DATA_LOGGER_BASE_URL}/v1`

const ToolLifeTrackingService = {
  getToolsUsage: async (params) => {
    try {
      const response = await axios.get(`${BASE_URL}/tool-life-monitoring-log`, {
        params: params
      })
      return response
    } catch (err) {
      console.log(err)
      return err.response
    }
  }
}
export default ToolLifeTrackingService
